module.exports = __webpack_public_path__ + "static/media/smiling-emoji-svgrepo-com (1).b7797b39.svg";